<template>
  <div class="mod-mpconfig">
    <el-form
      :inline="true"
      :model="searchForm"
      @keyup.enter.native="getDataList()"
    >
      <el-form-item>
        <el-input v-model="searchForm.appId" placeholder="appId" clearable />
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()"> 查询 </el-button>
        <el-button
          v-if="isAuth('wx:mpconfig:save')"
          type="primary"
          @click="addOrUpdateHandle()"
        >
          新增
        </el-button>
        <el-button
          v-if="isAuth('wx:mpconfig:delete')"
          type="danger"
          :disabled="dataListSelections.length <= 0"
          @click="deleteHandle()"
        >
          批量删除
        </el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      style="width: 100%"
      @selection-change="selectionChangeHandle"
    >
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50"
      />
      <el-table-column
        prop="appId"
        header-align="center"
        align="center"
        label="appId"
      />
      <el-table-column
        prop="secret"
        header-align="center"
        align="center"
        label="secret"
      />
      <el-table-column
        prop="token"
        header-align="center"
        align="center"
        label="token"
      />
      <el-table-column
        show-tooltip-when-overflow
        prop="content"
        header-align="center"
        align="center"
        label="关注后回复"
      />
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="220"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            v-if="isAuth('wx:mpconfig:info')"
            type="text"
            size="small"
            @click="showDetails(scope.row.id)"
          >
            查看
          </el-button>
          <el-button
            v-if="isAuth('wx:mpconfig:update')"
            type="text"
            size="small"
            @click="addOrUpdateHandle(scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            v-if="isAuth('wx:mpconfig:delete')"
            type="text"
            size="small"
            @click="deleteHandle(scope.row.id)"
          >
            删除
          </el-button>
          <el-button
            type="text"
            size="small"
            @click="mpConfig(scope.row.appId)"
          >
            菜单配置
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    />
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
    />
    <el-dialog
      width="80%"
      :close-on-click-modal="false"
      :visible.sync="wechatVisible"
    >
      <wechat
        title="公众号菜单配置"
        :data="data"
        @pubData="pubData"
        @delData="delData"
        @saveData="saveData"
      />
    </el-dialog>
  </div>
</template>

<script>
import AddOrUpdate from './mpconfig-add-or-update';
import wechat from '@/components/wechat';

export default {
  components: {
    AddOrUpdate,
    wechat,
  },
  data() {
    return {
      data: {
        button: [],
      },
      searchForm: {
        appId: '',
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListSelections: [],
      addOrUpdateVisible: false,
      wechatVisible: false,
    };
  },
  activated() {
    this.getDataList();
  },
  methods: {
    mpConfig(appId) {
      this.wechatVisible = true;
      this.getWxMenu(appId);
    },
    getWxMenu(appId) {
      this.$http({
        url: `/sys/wx/menu/getMenuByDb`,
        method: 'get',
        params: {
          appId: appId,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          if (data.menu) {
            this.data = JSON.parse(data.menu);
          } else {
            this.data = { button: [] };
          }
        }
      });
    },
    // 保存菜单到数据库
    saveData(form) {
      this.$http({
        url: `/sys/wx/menu/menuCreateByDb`,
        method: 'post',
        data: form,
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$message({
            message: '保存成功',
            type: 'success',
            duration: 1500,
          });
        }
      });
    },
    // 发布菜单到微信
    pubData() {
      this.$http({
        url: `/sys/wx/menu/push`,
        method: 'post',
        data: { buttons: this.data.button },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$message({
            message: '发布成功',
            type: 'success',
            duration: 1500,
          });
        }
      });
    },
    // 删除数据库中保存的菜单
    delData() {
      this.$http({
        url: `/sys/wx/menu/menuDeleteByDb`,
        method: 'post',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$message({
            message: '删除成功',
            type: 'success',
            duration: 1500,
          });
        }
      });
    },
    // 获取数据列表
    getDataList() {
      this.$http({
        url: '/wx/mpconfig/list',
        method: 'get',
        params: {
          page: this.pageIndex,
          limit: this.pageSize,
          appId: this.searchForm.appId,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.page.records;
          this.totalPage = data.page.total;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 查看详情
    showDetails(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, true);
      });
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 删除
    deleteHandle(id) {
      let ids = id
        ? [id]
        : this.dataListSelections.map((item) => {
            return item.id;
          });
      this.$confirm(`确定对[id=${ids.join(',')}]进行[删除]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http({
            url: '/wx/mpconfig/delete',
            method: 'post',
            data: ids,
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
              });
              this.getDataList();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
